define("shared/components/shared/post/secondary/hashtag-suggestions/upsell-modal", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="o--modalCard--secondary"
    {{did-insert @trackModalOpened}}
    {{did-insert (perform @fetchCaptionHashtags)}}
    {{will-destroy @cancelFetchingCaptionHashtags}}
  >
    <Shared::Post::Secondary::HashtagSuggestions::ModalHeader @showHelp={{false}} />
    {{#if (and this.isFree @isInstagram)}}
      <Shared::Post::Secondary::HashtagSuggestions::FreeUpgradeModal />
      <div class="o--modalFooter">
        <Shared::Ui::Button
          class="qa--postmodal_htDone"
          @type="outline"
          @additional="block"
          @text={{t "shared_words.close"}}
          @onClick={{@toggle}}
        />
      </div>
    {{else}}
      <Shared::Post::Secondary::HashtagSuggestions::PaidUpgradeModal
        @href="https://docs.later.com/scheduling-with-later/which-features-can-help-me-write-my-captions"
        @upgradeDescription={{@upgradeDescription}}
        @upgradeTitle={{t "hashtag_suggestions.limited.upgrade.title"}}
      />
      <div class="o--modalFooter">
        <Shared::Ui::Button
          class="o--btn o--btn--proceed o--btn--block qa--hashtag_suggestions_upgrade_btn at--onboardingV1__hashtagSuggestionsUpgrade"
          @text={{t (if @isEligibleForTrial "hashtag_suggestions.search.upgrade_cta_trial" "hashtag_suggestions.search.upgrade_cta")}}
          @onClick={{@goToPlansPage}}
        />
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "/q3mnDyV",
    "block": "[[[11,0],[24,0,\"o--modalCard--secondary\"],[4,[38,0],[[30,1]],null],[4,[38,0],[[28,[37,1],[[30,2]],null]],null],[4,[38,2],[[30,3]],null],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@showHelp\"],[false]],null],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"isFree\"]],[30,4]],null],[[[1,\"    \"],[8,[39,6],null,null,null],[1,\"\\n    \"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n      \"],[8,[39,7],[[24,0,\"qa--postmodal_htDone\"]],[[\"@type\",\"@additional\",\"@text\",\"@onClick\"],[\"outline\",\"block\",[28,[37,8],[\"shared_words.close\"],null],[30,5]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,9],null,[[\"@href\",\"@upgradeDescription\",\"@upgradeTitle\"],[\"https://docs.later.com/scheduling-with-later/which-features-can-help-me-write-my-captions\",[30,6],[28,[37,8],[\"hashtag_suggestions.limited.upgrade.title\"],null]]],null],[1,\"\\n    \"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n      \"],[8,[39,7],[[24,0,\"o--btn o--btn--proceed o--btn--block qa--hashtag_suggestions_upgrade_btn at--onboardingV1__hashtagSuggestionsUpgrade\"]],[[\"@text\",\"@onClick\"],[[28,[37,8],[[52,[30,7],\"hashtag_suggestions.search.upgrade_cta_trial\",\"hashtag_suggestions.search.upgrade_cta\"]],null],[30,8]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"@trackModalOpened\",\"@fetchCaptionHashtags\",\"@cancelFetchingCaptionHashtags\",\"@isInstagram\",\"@toggle\",\"@upgradeDescription\",\"@isEligibleForTrial\",\"@goToPlansPage\"],false,[\"did-insert\",\"perform\",\"will-destroy\",\"shared/post/secondary/hashtag-suggestions/modal-header\",\"if\",\"and\",\"shared/post/secondary/hashtag-suggestions/free-upgrade-modal\",\"shared/ui/button\",\"t\",\"shared/post/secondary/hashtag-suggestions/paid-upgrade-modal\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/upsell-modal.hbs",
    "isStrictMode": false
  });

  let UpsellModalComponent = (_class = class UpsellModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);
    }

    get isFree() {
      var _this$auth$currentAcc;

      return !((_this$auth$currentAcc = this.auth.currentAccount) !== null && _this$auth$currentAcc !== void 0 && _this$auth$currentAcc.hasActiveSubscription);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = UpsellModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpsellModalComponent);
});